export enum PageEnum {
  // basic login path
  BASE_LOGIN = '/login',
  // basic home path
  BASE_HOME = '/dashboard/home',
  // error page path
  ERROR_PAGE = '/exception',
  // error log page path
  ERROR_LOG_PAGE = '/error-log/list',
  // register page path
  REGISTER = '/register',
  // 结算单详情
  STATEMENTS_DETAIL = '/statements/detail/',
  // 药企端结算单详情
  PROJECT_STATEMENTS_DETAIL = '/projectForPartner/statement/detail/',
  // 新建结算单
  PROJECT_STATEMENT_CREATE = '/project/statement/create',
  // 回款详情
  COLLECTION_DETAIL = '/collectionManagement/collection/detail',
  // 付款详情
  PROJECT_COLLECTION_DETAIL = '/projectForPartner/collection/detail',
}

export enum StatementCreateSourceEnum {
  PROJECT_LIST = 'project-list',
  PROJECT_DETAIL = 'project-detail',
  COMMON_DRAWER = 'common-drawer',
}
